// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.myInfo {
    width: 80%;
    margin: 0 auto;
    padding: 48px 0;
    text-align: left;
    font-size: 16px;
}

.myInfo #modifyPwBtn {
    padding: 8px 24px;
    margin-left: 6.4px;
}

.myInfo #modifyPwBtn:hover {
    background-color: #444444;
}

.myInfoHeader {
    background-color: #676767;
    color: white;
    padding: 12.8px 17.6px;
    font-weight: bold;
    font-size: 19.2px;
    margin-bottom: 32px;
}

.myInfo > ul {
    list-style: none;
    padding: 0;
    margin-bottom: 48px;
}

.myInfo > ul input {
    max-width: 130px;
    width: 25%;
    height: 23.2px;
    padding: 3px 4px;
    border: 1px solid #dcdcdc;
    margin: 0 6.4px;
}

.myInfo > ul > li {
    display: flex;
    margin: 16px 0;
    align-items: flex-start;
    font-size: 16px;
}

.myInfo > ul > li > div {
    width: 80%;
}

.myInfo > ul > li p {
    font-size: 14.4px;
    margin: auto 0 auto 6.4px;
}

.myInfo > ul > li span {
    margin: auto 0;
}

.myInfo > ul > li label {
    background-color: #f5f5f5;
    font-size: 12.8px;
    width: 10%;
    min-width: 80px;
    padding: 8px 16px;
    margin-right: 9.6px;
}


.myInfoController {
    text-align: center;;
}

#saveMyInfoBtn {
    font-size: 14.4px;
    padding: 8px 24px;
    width: 160px;
}

@media screen and (max-width: 600px) {
    .myInfo {
        width: 100%;
    }

    .myInfo > ul > li {
        flex-direction: column;
    }

    .myInfo > ul > li label {
        width: calc(100% - 32px);
        margin: 0 0 10px 0;
    }

    .myInfo > ul > li > div{
        width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/MyInfo.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;;AAGA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;QACxB,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".myInfo {\n    width: 80%;\n    margin: 0 auto;\n    padding: 48px 0;\n    text-align: left;\n    font-size: 16px;\n}\n\n.myInfo #modifyPwBtn {\n    padding: 8px 24px;\n    margin-left: 6.4px;\n}\n\n.myInfo #modifyPwBtn:hover {\n    background-color: #444444;\n}\n\n.myInfoHeader {\n    background-color: #676767;\n    color: white;\n    padding: 12.8px 17.6px;\n    font-weight: bold;\n    font-size: 19.2px;\n    margin-bottom: 32px;\n}\n\n.myInfo > ul {\n    list-style: none;\n    padding: 0;\n    margin-bottom: 48px;\n}\n\n.myInfo > ul input {\n    max-width: 130px;\n    width: 25%;\n    height: 23.2px;\n    padding: 3px 4px;\n    border: 1px solid #dcdcdc;\n    margin: 0 6.4px;\n}\n\n.myInfo > ul > li {\n    display: flex;\n    margin: 16px 0;\n    align-items: flex-start;\n    font-size: 16px;\n}\n\n.myInfo > ul > li > div {\n    width: 80%;\n}\n\n.myInfo > ul > li p {\n    font-size: 14.4px;\n    margin: auto 0 auto 6.4px;\n}\n\n.myInfo > ul > li span {\n    margin: auto 0;\n}\n\n.myInfo > ul > li label {\n    background-color: #f5f5f5;\n    font-size: 12.8px;\n    width: 10%;\n    min-width: 80px;\n    padding: 8px 16px;\n    margin-right: 9.6px;\n}\n\n\n.myInfoController {\n    text-align: center;;\n}\n\n#saveMyInfoBtn {\n    font-size: 14.4px;\n    padding: 8px 24px;\n    width: 160px;\n}\n\n@media screen and (max-width: 600px) {\n    .myInfo {\n        width: 100%;\n    }\n\n    .myInfo > ul > li {\n        flex-direction: column;\n    }\n\n    .myInfo > ul > li label {\n        width: calc(100% - 32px);\n        margin: 0 0 10px 0;\n    }\n\n    .myInfo > ul > li > div{\n        width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
